import getPublicApiConfig from '../Config/publicApiEnv'

class Urls {
  constructor(config) {
    this.config = config
  }

  getApiUrl(url, ms) {
    return `${this.config.api}/auth/${url}`
  }
}

export default new Urls(getPublicApiConfig(process.env.NODE_ENV))
